import * as yup from "yup";

import { rentMonthsBetween } from "ui/components/DateRangeRentPicker";

export const IGNORE_ERROR = "IGNORE";

export const FLEET_VEHICLE_CONTRACT_RENT_EDIT_FORM_SCHEMA = yup
  .object()
  .shape({
    offerRentId: yup
      .string()
      .nullable()
      .required("Molimo Vas da odaberete ponudu"),

    contractNumber: yup
      .string()
      .required(
        "Broj ugovora je obavezan podatak. Molimo Vas da kontaktirate administratora"
      ),

    contractDate: yup
      .string()
      .required("Datum ugovora je obavezan podatak"),

    contractRentTemplateId: yup
      .string()
      .required("Molimo Vas da odaberete predložak ugovora"),

    // --- RAZDOBLJE NAJMA ---
    // Datumi i trajanje se računaju jedno iz drugoga, ali korisnik ih smije i ručno prepisati,
    // pa se prije spremanja provjerava da se nisu razišli.
    rentEndDate: yup
      .date()
      .nullable()
      .test(
        "rent-end-after-start",
        "Završetak najma mora biti nakon početka",
        function (value) {
          const start = this.parent.rentStartDate;
          return !value || !start || new Date(value) > new Date(start);
        }
      ),

    rentDurationMonths: yup
      .number()
      .nullable()
      .min(1, "Trajanje najma mora biti barem 1 mjesec")
      .test(
        "rent-duration-matches-period",
        "Trajanje najma ne odgovara odabranom razdoblju",
        function (value) {
          const { rentStartDate, rentEndDate } = this.parent;
          if (!value || !rentStartDate || !rentEndDate) return true;

          const months = rentMonthsBetween(new Date(rentStartDate), new Date(rentEndDate));
          // Kraj mjeseca odstupa par dana (31.01. + 1 mj = 28.02.), pa se dopušta tolerancija.
          return Math.abs(months - value) <= 1;
        }
      ),

    // --- LESSOR (Najmodavac) ---
    lessorCompanyName: yup
      .string()
      .required("Naziv najmodavca je obavezan podatak"),

    lessorHeadquartersAddress: yup
      .string()
      .required("Adresa sjedišta najmodavca je obavezan podatak"),

    lessorPhoneNumber: yup
      .string()
      .required("Telefon najmodavca je obavezan podatak"),

    lessorPersonalIdentificationNumber: yup
      .string()
      .required("OIB najmodavca je obavezan podatak"),

    lessorSalesPersonName: yup
      .string()
      .required("Ime kontakt osobe je obavezan podatak"),

    lessorTransactionAccountNumber: yup
      .string()
      .required("Broj transakcijskog računa najmodavca je obavezan podatak"),

    // --- LESSEE (Najmoprimac) ---
    lesseeName: yup
      .string()
      .required("Ime i prezime / naziv najmoprimca je obavezan podatak"),

    lesseeAddress: yup
      .string()
      .required("Adresa najmoprimca je obavezan podatak"),

    lesseePersonalIdentificationNumber: yup
      .string()
      .required("OIB najmoprimca je obavezan podatak"),

    lesseePhoneNumber: yup
      .string()
      .nullable(),

    lesseeMobilePhoneNumber: yup
      .string()
      .nullable(),

    lesseeEmail: yup
      .string()
      .email("Unesite ispravnu email adresu")
      .required("Email najmoprimca je obavezan podatak"),

    lesseeAuthorizedRepresentativeName: yup
      .string()
      .required("Ovlaštena osoba najmoprimca je obavezan podatak"),

    // --- CONTRACT DETAILS ---
    deliveryTime: yup
      .string()
      .required("Rok isporuke je obavezan podatak"),

    placeOfVehicleDelivery: yup
      .string()
      .required("Mjesto isporuke vozila je obavezan podatak"),
  })
  .test(
    "lessee-phone-or-mobile-required",
    "Potrebno je unijeti telefon ili mobitel najmoprimca",
    function (value) {
      const phone = value?.lesseePhoneNumber?.trim();
      const mobile = value?.lesseeMobilePhoneNumber?.trim();

      if (phone || mobile) {
        return true;
      }

      return this.createError({
        path: "lesseeMobilePhoneNumber",
        message: "Potrebno je unijeti telefon ili mobitel najmoprimca",
      });
    }
  );
